import React, { useState } from 'react';
import commonStyles from '../BetSlip.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import BetLines from '../BetLines/BetLines';
import SystemCombinations from '../SystemCombinations/SystemCombinations';
import Actions from '../Actions/Actions';
import StakeInputContainer from '../StakeInputContainer/StakeInputContainer';
import {
    BET_PLACEMENT_SUBMIT_BUTTON_TYPES,
    BET_SLIP_TABS,
    PRODUCER_TYPES,
} from '../../../constants/defaultValues';
import Summary from '../Summary/Summary';
import Footer from '../Footer/Footer';
import betSlipCalculator from '../../../utils/betSlipCalculator';
import { changeBetSlipStakes, placeBet } from '../../../store/actions/betSlip';
import Validations from '../Validations/Validations';

const TicketDetails = props => {
    const dispatch = useDispatch();

    const betLines = useSelector(state => state.betSlip.betLines);
    const activeTab = useSelector(state => state.betSlip.activeTab);
    const stakes = useSelector(state => state.betSlip.stakes);
    const selectedDecision = useSelector(state => state.betSlip.selectedOddChangeDecision);
    const selectedCombinations = useSelector(state => state.betSlip.selectedCombinations);

    const [submitButtonType, setSubmitButtonType] = useState(
        BET_PLACEMENT_SUBMIT_BUTTON_TYPES.submit,
    );

    const { resetBetSlip } = props;

    const changeBetSlipStakeValues = ({ type, stake }) => {
        dispatch(changeBetSlipStakes({ type, stake }));
    };

    const submitTicket = async ({ oddChangeDecision } = {}) => {
        const { totalOdds, totalStake, toWin, expectedBetsCount, potentialPayout } =
            betSlipCalculator.calculateTicketDetails({
                betLines,
                activeTab,
                stakes,
                selectedCombinations,
            });

        const data = {
            totalStake: totalStake,
            totalOdds: totalOdds,
            expectedBets: expectedBetsCount,
            ticketType: activeTab,
            acceptanceType: oddChangeDecision || selectedDecision,
            maxPaymentAmount: potentialPayout,
            bets: betLines.map(betLine => ({
                ...betLine,
                marketName: betLine.marketTemplateName,
                marketLabel: betLine.marketLabel,
                producerType: betLine.isLive ? PRODUCER_TYPES.live : PRODUCER_TYPES.preMatch,
            })),
            systemValues: selectedCombinations.map(
                system => system + betSlipCalculator.getBankers(betLines).length,
            ),
        };

        dispatch(placeBet(data));
    };

    return (
        <div className={commonStyles.betSlipWrap}>
            <BetLines />
            <Validations />
            {betLines.length > 0 ? (
                <>
                    <SystemCombinations />
                    <Actions resetBetSlip={resetBetSlip} />
                    <StakeInputContainer
                        show={activeTab === BET_SLIP_TABS.combo.id}
                        type={BET_SLIP_TABS.combo.id}
                        stake={stakes[BET_SLIP_TABS.combo.id]}
                        setStake={changeBetSlipStakeValues}
                    />
                    <StakeInputContainer
                        show={activeTab === BET_SLIP_TABS.system.id}
                        type={BET_SLIP_TABS.system.id}
                        stake={stakes[BET_SLIP_TABS.system.id]}
                        setStake={changeBetSlipStakeValues}
                    />
                    <Summary />
                    <Footer
                        onPlaceBetClick={submitTicket}
                        submitButtonType={submitButtonType}
                        setSubmitButtonType={setSubmitButtonType}
                    />
                </>
            ) : null}
        </div>
    );
};

export default TicketDetails;
